"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableRoute = void 0;
exports.getTableRoute = '/table/';
//# sourceMappingURL=get.route.js.map